module.exports = __webpack_public_path__ + "fonts/Gilroy-Black.b8a3b3a9.ttf";